export default "__VITE_ASSET__C8KCOWwL__"